import { DESKTOP_DRAWER_WIDTH } from '../config/constants';
import { useIsMobile } from '../hooks';
import { Box, SxProps, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useMemo } from 'react';

type Pos = string | number;

export type PositionProps = SxProps & {
  children: React.ReactNode;
  open?: boolean;
  left?: Pos;
  top?: Pos;
  bottom?: Pos;
  right?: Pos;
  zIndex?: number;
  animate?: boolean;
};

export function Position({
  children,
  open,
  left,
  right,
  top,
  animate = true,
  ...rest
}: PositionProps) {
  const isString = typeof left === 'string';
  const { direction } = useTheme();
  const isRtl = direction === 'rtl';
  const isMobile = useIsMobile();

  const drawerWidth = useMemo(() => (isMobile ? 0 : DESKTOP_DRAWER_WIDTH), [isMobile]);

  const [openWidth, closedWidth] = useMemo(
    () => [isRtl ? -drawerWidth : drawerWidth, isRtl ? '50%' : '-50%'],
    [isRtl, drawerWidth],
  );

  const [openX, closedX] = useMemo(
    () => [isString ? 0 : openWidth, isString ? closedWidth : 0],
    [isString, openWidth, closedWidth],
  );

  return (
    <Box
      {...(open !== undefined &&
        animate && {
          component: motion.div,
          initial: false,
          animate: {
            x: open ? openX : closedX,
            top,
          },
          transition: {
            ease: 'linear',
          },
        })}
      sx={{
        position: 'fixed',
        left,
        right,
        top,
        ...rest,
      }}
    >
      {children}
    </Box>
  );
}
